export const Controls = {
  IdImportQuote: 'id-importQuote',
  IdLicenseAnsweredPlate: 'id-license-answered-plate',
  IdLicensePlate: 'id-license-plate',
  IdTabSettings: 'id-tab-settings',
  IdImportTemplate: 'id-full-import-template',
  IdChangeStatus: 'id-change-status',
  IdBodyshopEmail: 'id-bodyshop-email',
  IdVin: 'id-vin',
  IdBodyshopPhoneNr: 'id-bodyshop-phone-nr',
  IdBodyshopContactName: 'id-bodyshop-contact-name',
  IdShowPrices: 'id-show-prices',
  IdShowAudit: 'id-show-audit',
  IdShowAuditParameters: 'id-show-audit-parameters',
  IdReturnApprovalProcess: 'id-return-approval-process',
  IdEditPrice: 'id-edit-price',
  IdReopenOffer: 'id-reopen-offer',
  IdAddPartToCart: 'id-add-part-to-cart',
  IdDownloadSupplierInventory: 'id-modalImportInventory-export-button',
  IdPrioritySupplier: 'id-priority-supplier',
  IdShowOrderPrint: 'id-show-order-print-search-orders',
  IdRequoteOrdered: 'id-requote',
  IdReassignToBodyshop: 'id-reassign-to-bodyshop',
  IdEditReassign: 'id-edit-reassign',
  IdEvaluateSupplierSearchOrders: 'id-evaluate-supplier',
  IdDownloadPDF: 'id-download-pdf',
  IdCancelPart: 'id-cancel-part',
  IdReassignPart: 'id-reassign-part',
  IdSectionSupplierBuyer: 'id-section-buyer',
  IdExportOrderViewOrder: 'id-export-order-view-order',
  IdReopenPartButton: 'id-reopen-part-button',
  IdOrderReportScheduleButton: 'id-payment-button',
  IdReleaseOrderControl: 'id-release-order-control',
  IdImportSearchInventory: 'id-import-company',
  IdImportRegisterCompany: 'id-import-register-company',
  IdVehicleSession: 'id-vehicle-session',
  IdBodyshopSession: 'id-bodyshop-session',
  IdGlassSession: 'id-glass-session',
  IdTireSession: 'id-tire-session',
  IdSearchOrderStatusCards: 'id-search-order-status-cards',
  IdPreQuoteGlass: 'id-pre-quote-glass',
  IdPreQuoteTire: 'id-pre-quote-tire',
  IdRequoteAnswerTime: 'id-requote-answer-time',
  IdRequoteAnswerProcurementTime: 'id-search-order-requote-answer-time',
  IdRequoteNationalProcurement: 'id-search-order-requote-national',
  IdSearchProcurementRequotePartType: 'id-search-procurement-requote-part-type',
  IdSearchQuoteRequotePartType: 'id-search-quote-requote-part-type',
  IdBuyerManualAnswer: 'id-create-quote-add-manual-price',
  idCreateEditDinamicReport: 'id-create-edit-dinamic-report',
  IdHierarchyLevelsClaims: 'id-user-hierarchy-levels-control-claims',
  IdClaimConfigurations: 'id-claim-configurations-control',
  IdVisualIdentity: 'id-section-visualIdentity',
  IdShowInsurerColumnInClaimSearch: 'id-claim-show-insurer',
  IdShowDepreciation: 'id-claim-depreciation',
  IdShowShippingCompany: 'id-show-shipping-company',
  IdCancelPartQuoteSummary: 'id-cancel-part-quote-summary',
  IdFilterCanceledBySupplier: 'id-filter-canceled-by-supplier',
  IdBtnReturn: 'id-btn-return',
  IdBtnCardViewReassign: 'id-btn-cardViewReassign',
  IdBtnCardViewReassignBulk: 'id-btn-cardViewReassignBulk',
  IdBtnReturnOrderInClaim: 'id-btn-return-order-in-claim',
  IdPredefinedSearchCartPendingAnswer:
    'id-predefinedSearch-cartPendingAnswer-control',
  IdPredefinedSearchScreenClaims: 'id-predefinedSearch-search-claims-control',
  IdSortByOldestSearchClaim: 'id-sortbyoldest-search-claims-control',
  IdPredefinedSearch: 'id-predefined-search',
  IdSortByOldestSearch: 'id-sortbyoldest-search',
  IdAssignedCardStatus: 'id-assigned-card-status',
  IdTransitCardStatus: 'id-transit-card-status',
  IdDeliveredCardStatus: 'id-delivered-card-status',
  IdInvoicedCardStatus: 'id-invoiced-card-status',
  IdPaidCardStatus: 'id-paid-card-status',
  IdOpenCardStatus: 'id-open-card-status',
  IdManualCardStatus: 'id-manual-card-status',
  IdCanceledCardStatus: 'id-canceled-card-status',
  IdReceivedCardStatus: 'id-received-card-status',
  IdPrequoteCardStatus: 'id-prequote-card-status',
  IdReturnedCardStatus: 'id-returned-card-status',
  IdTransferredCardStatus: 'id-transferred-card-status',
  IdAwaitingReleaseCardStatus: 'id-awaiting-release-card-status',
  IdAwaitingPaymentCardStatus: 'id-awaiting-payment-card-status',
  IdFavouriteSearch: 'id-favouriteSearch-search',
  IdCreateOrderRequoteNational: 'id-create-order-requote-national',
  IdDownloadImagesSearchClaimsControl:
    'id-downloadImages-search-claims-control',
  IdDownloadImagesSearchOrdersControl:
    'id-downloadImages-search-orders-control',
  IdDownloadImagesAnsweredCartControl:
    'id-downloadImages-answered-cart-control',
  IdDownloadImagesPreQuoteControl: 'id-downloadImages-pre-quote-control',
  IdDownloadImagesCreateOrderControl: 'id-downloadImages-create-order-control',
  IdViewVehicleInFloorData: 'id-view-vehicle-in-floor-data',
  IdManagePartsRequote: 'id-manage-parts-requote',
  IdManagePartsReassign: 'id-manage-parts-reassign',
  IdManagePartsReassignToBodyshop: 'id-manage-parts-reassigntobodyshop',
  IdCompanyHistoricalInsurer: 'id-company-historical-insurer',
  IdCompanyHistoricalBodyshop: 'id-company-historical-bodyshop',
  IdCompanyHistoricalSupplier: 'id-company-historical-supplier',
  IdCompanyHistoricalValuator: 'id-company-historical-valuator',
  IdCompanyHistoricalSupervisor: 'id-company-historical-supervisor',
  IdSendUpdatesViewOrder: 'id-SendUpdatesManuallyQueued-search-orders-control',
  IdSearchOrderSummary: 'id-search-order-summary',
  IdSearchOrderPendingApproval:
    'id-PendingApprovalsButton-search-orders-control',
  IdSendUpdatesSearchClaim:
    'id-SendUpdatesManuallyQueued-search-claims-control',
  IdExpireDeadlineAnswer: 'id-expire-deadline-answer',
  IdHierarchyLevelsParts: 'id-user-hierarchy-levels-control-parts',
  IdEditEmailTemplate: 'id-edit-email-template-button'
};
